import { Text, WarningIcon } from '@/lib'
import { QuotationProductProps } from '@/types'
import { ReactNode } from 'react'

export const validateFields = {
  lastMileFreightCost: (
    fieldValue: number | undefined,
    t: (key: string) => string,
    styles: Record<string, string>,
  ): ReactNode | null => {
    if (fieldValue === undefined) return null

    if (fieldValue === 0) {
      return (
        <div className={styles['warning-message']}>
          <WarningIcon />
          <Text>{t('lastMileFreightCostZero')}</Text>
        </div>
      )
    }

    return null
  },
  customsFreightCost: (
    products: QuotationProductProps[],
    t: (key: string) => string,
    styles: Record<string, string>,
  ): ReactNode | null => {
    const hasForeignSupplier = products?.some(
      (product) => product?.supplier?.isForeign === true,
    )

    if (hasForeignSupplier) {
      return (
        <div className={styles['warning-message']}>
          <WarningIcon />
          <Text>{t('internationalSupplierWarning')}</Text>
        </div>
      )
    }

    return null
  },
}
